import { connect } from "react-redux";
import AppBarSearch from "./AppBarSearch";
import {
  getSuggestions,
  clearSuggestions,
  setInputValue
} from "./actions/search";

const mapStateToProps = (state, ownProps) => {
  return {
    suggestions: state.search.suggestions,
    inputValue: state.search.inputValue
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onSuggestionsFetchRequested: params => {
      dispatch(getSuggestions(params));
    },
    onSuggestionsClearRequested: () => {
      dispatch(clearSuggestions());
    },
    setInputValue: (event, { newValue }) => {
      dispatch(setInputValue(newValue));
    }
  };
};

const AppBarSearchContainer = connect(mapStateToProps, mapDispatchToProps)(
  AppBarSearch
);

export default AppBarSearchContainer;



// WEBPACK FOOTER //
// ./src/AppBarSearchContainer.js